import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import veterinarySymptomDeleteAction from './veterinarySymptomDelete.action.json' with { type: 'json' }
import { veterinarySymptomObject } from '../veterinarySymptomObject'

const veterinarySymptomDeleteDefinition = defineAction({
  ...veterinarySymptomDeleteAction,

  input: veterinarySymptomObject.pick({
    id: true,
  }),
  output: z.object({}),
})

export default veterinarySymptomDeleteDefinition
